import {createAction, props} from '@ngrx/store';

export enum PersistStoreActions {
  POBIERZ_STORE = '[Samoobsluga] Pobierz store z bazy danych',
  POBRANO_STORE = '[Samoobsluga] Pobrano store z bazy danych'
}

export const pobierzStore = createAction(PersistStoreActions.POBIERZ_STORE, props<{ correlationId: string }>());
export const pobranoStoreSuccess = createAction(PersistStoreActions.POBRANO_STORE, props<any>());
